import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteOverviewActions'
import * as api from '../../api/job/jobSiteOverview'

function* jobSiteOverviewsRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteOverviews, action.jobId)
    yield put({ type: constants.JOB_SITE_OVERVIEWS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_OVERVIEWS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteOverviews() {
  yield takeLatest(constants.JOB_SITE_OVERVIEWS_REFRESH.ACTION, jobSiteOverviewsRefresh)
}

function* sagaUpdateJobSiteOverview(action) {
  try {
    const payload = {
      job_id: action.jobId,
      note: action.note,
      user_id: action.userId
    }
    yield call(api.updateJobSiteOverview, payload)
    yield put({ type: constants.JOB_SITE_OVERVIEW_UPDATE.SUCCESS, payload })
    yield call(jobSiteOverviewsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_OVERVIEW_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteOverview() {
  yield takeLatest(constants.JOB_SITE_OVERVIEW_UPDATE.ACTION, sagaUpdateJobSiteOverview)
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchJobSiteOverviews), fork(watchUpdateJobSiteOverview)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteOverviewSaga.js